<div (mouseenter) ="isHover = true; wordflick();" (mouseleave) ="isHover = false;" fxLayout="row" class="chat-panel-toggle" (click)="openChat()">
  <span [matBadge]="getWorkerCount()" matBadgePosition="before" matBadgeColor="accent"></span>
  <button color="primary" type="button" class="btn-class">
    <div fxLayout="row">
      <img src="../../../assets/img/worker.png" class="img-class" [ngClass]="{'mr-3': isFisrtTime}"> 
      <b id="word"></b>
    </div>
  </button>
</div> 